export class UpdateGradeCalculationFailure {
    static readonly type = '[GradingScheme] UpdateGradeCalculationFailure';
}
